import InfoBox, { IPropsInfoBox } from '../InfoBox/Infobox';
import { makeStyles, createStyles } from '@material-ui/core';
import { ITheme } from '../../common/theme';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    verticalAlign: {
      ...theme.mixins.wrapper,
      ...theme.mixins.verticalAlign,
      justifyContent: 'center',
      minHeight: '80%',
    },
  })
);
const ErrorInfoBox = ({ title, subtitle, onClick, buttonText }: IPropsInfoBox & { buttonText?: string; onClick?: () => void }) => {
  const { t } = useTranslation(['common']);
  const classes = useStyles();
  return (
    <div className={classes.verticalAlign}>
      <InfoBox
        title={title}
        subtitle={subtitle}
        leftButton={{
          variant: 'contained',
          text: buttonText || t('button.reload'),
          onClick: onClick || (() => window.location.reload()),
        }}
      />
    </div>
  );
};

export default ErrorInfoBox;
